import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import RestaurantForm from '../components/restaurants/RestaurantForm';
import { createRestaurant } from '../services/restaurantService';

function AddRestaurant() {
  const handleSubmit = async (formData) => {
    const restaurantId = await createRestaurant(formData);
    return restaurantId;
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Add New Restaurant
        </Typography>
        <RestaurantForm onSubmit={handleSubmit} />
      </Box>
    </Container>
  );
}

export default AddRestaurant;